import React, {Component} from 'react';
import {sortByProperty} from 'helpers/sorters';
import Const from 'constants';
import {calcPercentage} from 'helpers/common-helper';
import {StackTeamExposureInput} from 'components/organisms/stack-summary/components/stack-team-exposure-input';

class BaseStackSummary extends Component {
    prepareGroups() {
        const {stacking, rawLineups, lineupTeamsStacks} = this.props;

        function initGroup(groupNumber) {
            return {
                teams: {},
                playersQuantity: stacking.getPlayersQuantityByGroupNumber(groupNumber),
            };
        }

        function initTeam(teamName) {
            return {
                teamName,
                quantity: 0,
            };
        }

        const groups = {};
        rawLineups.asArr().map((lineup) => {
            const splittedGroups = lineup.getSplitted(Const.LP_TEAM_GROUP_PREFIX);
            splittedGroups.map((splittedGroup) => {
                const [teamName, groupNumber] = splittedGroup;

                if (!groupNumber) {
                    return;
                }

                if (!groups.hasOwnProperty(groupNumber)) {
                    groups[groupNumber] = initGroup(groupNumber);
                }

                if (!groups[groupNumber].teams.hasOwnProperty(teamName)) {
                    groups[groupNumber].teams[teamName] = initTeam(teamName);
                }

                groups[groupNumber].teams[teamName].quantity++;
            });
        });

        const items = lineupTeamsStacks.exposureMax.all();
        Object.keys(items).map((groupNumber) => {
            if (!groups.hasOwnProperty(groupNumber)) {
                groups[groupNumber] = initGroup(groupNumber);
            }
            Object.keys(items[groupNumber]).map((teamName) => {
                if (!groups[groupNumber].teams.hasOwnProperty(teamName)) {
                    groups[groupNumber].teams[teamName] = initTeam(teamName);
                }
            });
        });

        Object.keys(groups).map((groupNumber) => {
            let teams = Object.values(groups[groupNumber].teams);
            teams.sort(sortByProperty('quantity', 'desc'));
            groups[groupNumber].teams = [...teams];
        });

        return {...groups};
    }

    countTeams(groups) {
        let teams = [];
        Object.values(groups).map((group) => {
            group.teams.map((item) => {
                if (!inArray(item.teamName, teams)) {
                    teams.push(item.teamName);
                }
            });
        });
        return teams.length;
    }

    getNotFoundView() {
        return (
            <table key={-1} className="table">
                <tbody>
                    <tr key="teams-not-found" className="empty">
                        <td>Teams were not found.</td>
                    </tr>
                </tbody>
            </table>
        );
    }

    getTeamStackView(teamNumber, stackNumber, groupItem) {
        const {rawLineups} = this.props;
        const percentage = calcPercentage(rawLineups.getQuantity(), groupItem.quantity);
        const className = teamNumber % 2 === 0 ? 'even' : '';

        return (
            <tr key={groupItem.teamName} className={className}>
                <td>
                    <strong>{groupItem.teamName}</strong>
                </td>
                <td className="text-blue">
                    {percentage}% ({groupItem.quantity})
                </td>
                <td>
                    <div className="percent-in">
                        <StackTeamExposureInput groupNumber={stackNumber} team={groupItem.teamName} />
                        <span className="percent">%</span>
                    </div>
                </td>
            </tr>
        );
    }

    getTeamsStackView(groupNumber, stackGroup) {
        const rows = [];
        stackGroup.teams.map((item, i) => {
            rows.push(this.getTeamStackView(i, groupNumber, item));
        });

        return (
            <table key={groupNumber} className="table">
                <thead>
                    <tr>
                        <th>{`${stackGroup.teams.length} Teams Used in ${stackGroup.playersQuantity} Players Stack`}</th>
                        <th></th>
                        <th>
                            Exp.
                            <br />
                            max
                        </th>
                    </tr>
                </thead>
                <tbody>{rows}</tbody>
            </table>
        );
    }
}

export {BaseStackSummary};
